<template>
  <TText size="lg" classes="mb-7 text-center">
    {{ text }}
  </TText>
</template>

<script setup lang="ts">
export interface propsInterface {
  text?: string
}

defineProps<propsInterface>()
</script>
